import React from 'react'
import { Spin } from 'antd'
import { ImPacman } from "react-icons/im";

type Props = {
  description?: string,
  children?: React.ReactComponentElement<never> | React.ReactElement,
}
function Loading({ description = "Loading please wait...", children }: Props) {
  return (
    <Spin
      fullscreen
      size='large'
      className='w-full min-h-screen flex flex-col justify-center items-center'
      indicator={<div className='!w-[50%] flex flex-col justify-center items-center gap-10'>
        <ImPacman className='!block !mx-auto !text-5xl !text-primary !animate-spin' />
        <p className='text-sm font-normal text-white whitespace-nowrap text-center'>{description}</p>
      </div>}
    >
      {children}
    </Spin>
  )
}

export default Loading